import { i18nPrice } from '@shared/fondof-fn/format/price'
import { gidToId } from '@shared/shop-api/core/helper'
import type { ProductVariantFragment } from '@shared/types/storefront/graphql'

export const toProductVariant = (productVariant: ProductVariantFragment) => {
  const price = parseFloat(productVariant.price.amount)
  const originalPrice = parseFloat(
    productVariant.compareAtPrice?.amount ?? productVariant.price.amount
  )
  const discount =
    price === 0 ? 100 : Math.round(100 - (price * 100) / originalPrice)
  const size = productVariant.selectedOptions?.find(
    (option) => option.name.toLowerCase() === 'size'
  )?.value

  return {
    id: gidToId(productVariant.id),
    sku: productVariant.sku ?? '',
    available: productVariant.availableForSale,
    priceFormatted: i18nPrice(price, productVariant.price.currencyCode),
    price,
    originalPriceFormatted: i18nPrice(
      originalPrice,
      productVariant.price.currencyCode
    ),
    gtin: productVariant.gtin ?? undefined,
    originalPrice,
    discount,
    isOffer: price !== originalPrice,
    currencyCode: productVariant.price.currencyCode,
    size,
    displaySize: size === 'one_size' ? undefined : size?.toUpperCase(),
  }
}
